export enum Role {
  Admin = 'Admin',
  Student = 'Student',
  Guide = 'Guide',
}
